module.exports = __webpack_public_path__ + "img/2.a0b7b298.jpg";